import { styled, css } from '@vebox/etui-system';
import { omit } from '../utilities/omit.js';
import { Component, createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Tr as Tr$1 } from '@vebox/etui-system-elements';
import { T as Td } from '../Td-2423cb3a.js';

const Tr = styled(Tr$1)`
  &:hover {
    ${Td} {
      ${({
  onClick,
  theme
}) => {
  if (onClick) {
    return css`
            background-color: ${theme.palette.action.hover};
            cursor: pointer;
          `;
  }
  return ``;
}};
    }
  }

  :last-of-type {
    ${Td} {
      border-bottom: none;
    }
  }
`;

function createTableRow() {
  class BodyRow extends Component {
    constructor(props) {
      super(props);
      this.store = props.store;
      let selectedKeys = [];
      if (this.store) {
        const {
          selectedRowKeys
        } = this.store.getState();
        selectedKeys = selectedRowKeys || [];
      }
      this.state = {
        selected: selectedKeys.indexOf(props.rowKey) >= 0
      };
    }
    componentDidMount() {
      this.subscribe();
    }
    componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }
    subscribe() {
      const {
        store,
        rowKey
      } = this.props;
      if (store) {
        this.unsubscribe = store.subscribe(() => {
          const {
            selectedRowKeys
          } = this.store.getState();
          const selected = selectedRowKeys.indexOf(rowKey) >= 0;
          if (selected !== this.state.selected) {
            this.setState({
              selected
            });
          }
        });
      }
    }
    render() {
      const rowProps = omit(this.props, ['prefixCls', 'rowKey', 'store']);
      return /*#__PURE__*/createElement(Tr, rowProps, this.props.children);
    }
  }
  return BodyRow;
}

export default createTableRow;
